import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from '@utils/cn';
import { ProgressData, ProgressProps } from './types';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef, HTMLAttributes, useId } from 'react';

const Bar = ({
  bar,
  value,
  style,
  className,
  ...props
}: ProgressData & HTMLAttributes<HTMLDivElement>) => (
  <ProgressPrimitive.Indicator
    className={cn('absolute h-full w-full flex-1 rounded-r-full transition-all', bar, className)}
    style={{ transform: `translateX(-${100 - (value || 0)}%)`, ...style }}
    {...props}
  />
);

const Progress = forwardRef<
  ComponentRef<typeof ProgressPrimitive.Root>,
  ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & ProgressProps
>(({ className, bar = 'bg-neutral-900', bg = 'bg-neutral-100', value, data, ...props }, ref) => {
  const id = useId();

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('relative h-4 w-full overflow-hidden rounded-full', className, bg)}
      {...props}>
      {Boolean(value) && <Bar bar={bar} value={Number(value)} />}
      {Boolean(data?.length) &&
        data?.map((el, i) => (
          <Bar
            key={`progress-bar-${id}-${i}`}
            bar={el.bar}
            value={el.value}
            style={{ zIndex: data.length - i }}
          />
        ))}
    </ProgressPrimitive.Root>
  );
});

// eslint-disable-next-line immutable/no-mutation
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
